module.exports = __webpack_public_path__ + "img/Luxury-Category.321620a8.jpg";